import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';

import Home from './pages/Home';
import Header from './components/Header';
import Footer from './components/Footer';
import FreeTrialButton from './pages/FreeTrialButton'; 
import Why from './pages/Why';
import HealthcareAI from './pages/HealthcareAI';
import Resources from './pages/Resources';
import DenialCodes from './pages/DenialCodes';
import Company from './pages/Company';
import Career from './pages/Career';
import EligibilityCheck from './pages/EligibilityCheck';
import PolicyStatusVerification from './pages/PolicyStatusVerification';
import PriorAuthorization from './pages/PriorAuthorization';
import InsuranceContractRepricing from './pages/InsuranceContractRepricing';
import PatientIntake from './pages/PatientIntake';
import DenialManagement from './pages/DenialManagement'; 
import PaymentPosting from './pages/PaymentPosting';
import AccountsReceivable from './pages/AccountsReceivable';
import ComplianceAgent from './pages/ComplianceAgent';
import NewsBlog from './pages/NewsBlog';
import BlogDetail from './pages/BlogDetail';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FreeTrial from './pages/FreeTrial';
import Dental from './pages/Dental';
import MentalHealth from './pages/MentalHealth';
import Compliance from './pages/Compliance';
import Events from './pages/Events';
import Testimonials from './components/Testimonials';
import HiddenRevenueOpportunities from './components/HiddenRevenueOpportunities';

// ✅ EXISTING SERVICE PAGES
import MedicalBillingOutsourcing from './pages/MedicalBillingOutsourcing';
import HospitalRCM from './pages/HospitalRCM';
import RCMConsulting from './pages/RCMConsulting';

// ✅✅ NEW SEO-OPTIMIZED SERVICE PAGES (Low-Competition Keywords)
import MedicalBillingSmallPractices from './pages/MedicalBillingSmallPractices';
import ReduceClaimDenials from './pages/ReduceClaimDenials';
import RCMIndependentPhysicians from './pages/RCMIndependentPhysicians';
import DenialManagementClinics from './pages/DenialManagementClinics';
import RCMMultispecialtyPractices from './pages/RCMMultispecialtyPractices';
import BenefitsMedicalBillingOutsourcing from './pages/BenefitsMedicalBillingOutsourcing';

// ✅✅ PRICING PAGE
import Pricing from './pages/Pricing';
import MDeRCMChatbot from './components/MDeRCMChatbot';



function App() {
  return (
    <Router>
       <ScrollToTop />
      <Header />
        <FreeTrialButton />
      <Routes>
        {/* Main Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/why" element={<Why />} />
        <Route path="/healthcare/ai" element={<HealthcareAI />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/resources/denial-codes" element={<DenialCodes />} />
        <Route path="/company" element={<Company />} />
        <Route path="/careers" element={<Career />} />

        {/* ✅✅ PRICING PAGE */}
        <Route path="/pricing" element={<Pricing />} />

        {/* ✅ EXISTING SERVICE PAGES */}
        <Route path="/medical-billing-outsourcing" element={<MedicalBillingOutsourcing />} />
        <Route path="/hospital-revenue-cycle-management" element={<HospitalRCM />} />
        <Route path="/revenue-cycle-consulting" element={<RCMConsulting />} />
        
        {/* ✅✅ NEW SEO-OPTIMIZED SERVICE PAGES - LOW COMPETITION KEYWORDS */}
        <Route path="/medical-billing-outsourcing-small-practices" element={<MedicalBillingSmallPractices />} />
        <Route path="/reduce-claim-denials-healthcare-billing" element={<ReduceClaimDenials />} />
        <Route path="/revenue-cycle-management-independent-physicians" element={<RCMIndependentPhysicians />} />
        <Route path="/denial-management-services-medical-clinics" element={<DenialManagementClinics />} />
        <Route path="/revenue-cycle-management-multispecialty-practices" element={<RCMMultispecialtyPractices />} />
        <Route path="/benefits-medical-billing-outsourcing-clinics" element={<BenefitsMedicalBillingOutsourcing />} />
        
        {/* AI Services */}
        <Route path="/healthcare/ai/eligibility-check" element={<EligibilityCheck />} />
        <Route path="/healthcare/ai/policy-status-verification" element={<PolicyStatusVerification />} />
        <Route path="/healthcare/ai/prior-authorization" element={<PriorAuthorization />} />
        <Route path="/healthcare/ai/InsuranceContract-Repricing" element={<InsuranceContractRepricing />} />
        <Route path="/healthcare/ai/patient-intake" element={<PatientIntake />} />
        <Route path="/healthcare/ai/denial-management" element={<DenialManagement />} />
        <Route path="/healthcare/ai/payment-posting" element={<PaymentPosting />} />
        <Route path="/healthcare/ai/accounts-receivable" element={<AccountsReceivable />} />
        <Route path="/healthcare/ai/compliance-agent" element={<ComplianceAgent />} />
        
        {/* Blog Routes */}
        <Route path="/blog" element={<NewsBlog />} />
        <Route path="/blog/maximizing-healthcare-returns" element={<BlogDetail />} />
        <Route path="/blog/ai-vs-traditional-rcm" element={<BlogDetail />} />
        <Route path="/blog/upgrade-to-ai-revenue-cycle" element={<BlogDetail />} />
        <Route path="/blog/ai-simplify-revenue-cycle" element={<BlogDetail />} />
        <Route path="/blog/healthcare-revenue-cycle-management-services" element={<BlogDetail />} />
        <Route path="/blog/reducing-healthcare-costs-ai-rcm" element={<BlogDetail />} />
        <Route path="/blog/medical-billing-outsourcing-guide" element={<BlogDetail />} />
        <Route path="/blog/best-revenue-cycle-management-companies" element={<BlogDetail />} />
        <Route path="/blog/revenue-cycle-management-services-usa" element={<BlogDetail />} />
        <Route path="/blog/medical-billing-coding-outsourcing-guide" element={<BlogDetail />} />
        <Route path="/blog/hidden-revenue-opportunities-medical-billing" element={<BlogDetail />} />
        <Route path="/blog/selecting-best-rcm-companies-2026" element={<BlogDetail />} />

        {/* ✅✅ MENTAL HEALTH BLOG ROUTES */}
        <Route path="/blog/mental-health-billing-services-behavioral-health-rcm" element={<BlogDetail />} />
        <Route path="/blog/mental-health-rcm-services" element={<BlogDetail />} />

        {/* ✅✅ COST-EFFECTIVE RCM BLOG ROUTE */}
        <Route path="/blog/cost-effective-revenue-cycle-management-reduce-operational-costs" element={<BlogDetail />} />

        {/* ✅✅ AI HEALTHCARE RCM 2026 BLOG ROUTE - FEB 21, 2026 */}
        <Route path="/blog/best-ai-healthcare-revenue-cycle-management-2026" element={<BlogDetail />} />

        {/* ✅✅ MENTAL HEALTH & SUBSTANCE ABUSE RCM 2026 BLOG ROUTE - FEB 28, 2026 */}
        <Route path="/blog/mental-health-substance-abuse-rcm-billing-guide-2026" element={<BlogDetail />} />

        {/* ✅✅ BEHAVIORAL HEALTH RCM SOFTWARE BLOG - MARCH 3, 2026 */}
        <Route path="/blog/best-behavioral-health-rcm-software-companies-2026" element={<BlogDetail />} />

        {/* ✅✅ MEDICAL BILLING GURGAON BLOG - MARCH 3, 2026 */}
        <Route path="/blog/medical-billing-companies-gurgaon-india" element={<BlogDetail />} />

        {/* ✅✅ BEST RCM SMALL PRACTICES BLOG - MARCH 3, 2026 */}
        <Route path="/blog/best-rcm-software-small-medical-practices-2026" element={<BlogDetail />} />

        {/* ✅✅ AI-POWERED MEDICAL BILLING OUTSOURCING BLOG - MARCH 12, 2026 */}
        <Route path="/blog/ai-powered-medical-billing-outsourcing-services" element={<BlogDetail />} />

        {/* ✅✅ REVENUE CYCLE MANAGEMENT SERVICES BLOG - MARCH 20, 2026 */}
        <Route path="/blog/revenue-cycle-management-services" element={<BlogDetail />} />

        {/* ✅✅ UNDERPAID CLAIMS RECOVERY BLOG - APRIL 10, 2026 */}
        <Route path="/blog/underpaid-claims-recovery-healthcare-billing" element={<BlogDetail />} />

        {/* ✅✅ CLAIM REPRICING BLOG - APRIL 18, 2026 */}
        <Route path="/blog/claim-repricing-healthcare-billing-guide-2026" element={<BlogDetail />} />

        {/* ✅✅ HOME HEALTH CODING FLORIDA BLOG - APRIL 24, 2026 */}
        <Route path="/blog/home-health-coding-services-florida" element={<BlogDetail />} />

        {/* ✅✅ HOME HEALTH CODING FLORIDA COMPLETE GUIDE - APRIL 30, 2026 */}
        <Route path="/blog/home-health-coding-florida-guide-2026" element={<BlogDetail />} />

        {/* ✅✅ DRUG ADDICTION / SUBSTANCE ABUSE BILLING FLORIDA - APRIL 30, 2026 */}
        <Route path="/blog/drug-addiction-substance-abuse-billing-florida-2026" element={<BlogDetail />} />

        {/* ✅✅ ONCOLOGY BILLING & AI RCM FLORIDA - MAY 7, 2026 */}
        <Route path="/blog/oncology-billing-rcm-florida-2026" element={<BlogDetail />} />

        {/* ✅✅ BEHAVIORAL HEALTH REVENUE CYCLE MANAGEMENT 2026 - MAY 15, 2026 */}
        <Route path="/blog/behavioral-health-revenue-cycle-management-2026" element={<BlogDetail />} />

        {/* ✅✅ BEST MEDICAL BILLING COMPANY USA 2026 - MAY 21, 2026 */}
        <Route path="/blog/best-medical-billing-company-usa-2026" element={<BlogDetail />} />

        {/* ✅✅ DUAL DIAGNOSIS BILLING & RCM USA 2026 - MAY 29, 2026 */}
        <Route path="/blog/dual-diagnosis-billing-rcm-usa-2026" element={<BlogDetail />} />

        {/* Other Pages */}
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/free-trial" element={<FreeTrial />} />
        <Route path="/Dental" element={<Dental />} />
        <Route path="/MentalHealth" element={<MentalHealth />} />
        <Route path="/compliance" element={<Compliance />} />
        <Route path="/events" element={<Events />} />
        <Route path="/testimonials" element={<Testimonials />} />
      </Routes>
      <Footer />
      <MDeRCMChatbot />
    </Router>
  );
}

export default App;